
;(function seibertronPro3GalleryRestore20260713() {
  var handle = 'seibertron-pro-3-0-elite-ultra-stick-youth-football-receiver-gloves';
  var adultChartFile = 'football-pro3-adult-size-chart-vertical-20260713.png';
  var youthChartFile = 'football-pro3-youth-size-chart-vertical-20260713.png';
  var entries = [
    {
        "id": "33403644707006",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/1_cf597b59-1ea4-44b8-88b4-b566ed30f5d2.jpg?v=1783672472",
        "alt": "color:Pink | Seibertron Pro 3.0 youth football receiver gloves white background main image"
    },
    {
        "id": "33373093396670",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/football-pro3-youth-gallery-01.jpg?v=1783389183",
        "alt": "color:Pink | Seibertron Pro 3.0 ultra-stick football receiver gloves image 01"
    },
    {
        "id": "33373093429438",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/football-pro3-youth-gallery-02.jpg?v=1783389183",
        "alt": "color:Pink | Seibertron Pro 3.0 ultra-stick football receiver gloves image 02"
    },
    {
        "id": "33373093462206",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/football-pro3-youth-gallery-03.jpg?v=1783389183",
        "alt": "color:Pink | Seibertron Pro 3.0 ultra-stick football receiver gloves image 03"
    },
    {
        "id": "33434547486910",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-pro3-youth-football-gloves-red-white-bg-20260713.jpg?v=1783944370",
        "alt": "color:Red | Seibertron Pro 3.0 youth football receiver gloves white background main image"
    },
    {
        "id": "33373093494974",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/football-pro3-youth-gallery-04.jpg?v=1783389183",
        "alt": "color:Red | Seibertron Pro 3.0 ultra-stick football receiver gloves image 04"
    },
    {
        "id": "33373093527742",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/football-pro3-youth-gallery-05.jpg?v=1783389183",
        "alt": "color:Red | Seibertron Pro 3.0 ultra-stick football receiver gloves image 05"
    },
    {
        "id": "33373093560510",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/football-pro3-youth-gallery-06.jpg?v=1783389183",
        "alt": "color:Red | Seibertron Pro 3.0 ultra-stick football receiver gloves image 06"
    },
    {
        "id": "33434546667710",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-pro3-youth-football-gloves-white-white-bg-20260713.jpg?v=1783944358",
        "alt": "color:White | Seibertron Pro 3.0 youth football receiver gloves white background main image"
    },
    {
        "id": "33373093593278",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/football-pro3-youth-gallery-07.jpg?v=1783389183",
        "alt": "color:White | Seibertron Pro 3.0 ultra-stick football receiver gloves image 07"
    },
    {
        "id": "33373093626046",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/football-pro3-youth-gallery-08.jpg?v=1783389183",
        "alt": "color:White | Seibertron Pro 3.0 ultra-stick football receiver gloves image 08"
    },
    {
        "id": "33373093658814",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/football-pro3-youth-gallery-09.jpg?v=1783389183",
        "alt": "color:White | Seibertron Pro 3.0 ultra-stick football receiver gloves image 09"
    },
    {
        "id": "33434546897086",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-pro3-youth-football-gloves-black-white-bg-20260713.jpg?v=1783944361",
        "alt": "color:Black | Seibertron Pro 3.0 youth football receiver gloves white background main image"
    },
    {
        "id": "33373093691582",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/football-pro3-youth-gallery-10.jpg?v=1783389183",
        "alt": "color:Black | Seibertron Pro 3.0 ultra-stick football receiver gloves image 10"
    },
    {
        "id": "33373093724350",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/football-pro3-youth-gallery-11.jpg?v=1783389183",
        "alt": "color:Black | Seibertron Pro 3.0 ultra-stick football receiver gloves image 11"
    },
    {
        "id": "33373093757118",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/football-pro3-youth-gallery-12.jpg?v=1783389183",
        "alt": "color:Black | Seibertron Pro 3.0 ultra-stick football receiver gloves image 12"
    },
    {
        "id": "33434548142270",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-pro3-youth-football-gloves-yellow-white-bg-20260713.jpg?v=1783944376",
        "alt": "color:Yellow | Seibertron Pro 3.0 youth football receiver gloves white background main image"
    },
    {
        "id": "33373093789886",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/football-pro3-youth-gallery-13.jpg?v=1783389183",
        "alt": "color:Yellow | Seibertron Pro 3.0 ultra-stick football receiver gloves image 13"
    },
    {
        "id": "33373093822654",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/football-pro3-youth-gallery-14.jpg?v=1783389183",
        "alt": "color:Yellow | Seibertron Pro 3.0 ultra-stick football receiver gloves image 14"
    },
    {
        "id": "33373093855422",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/football-pro3-youth-gallery-15.jpg?v=1783389183",
        "alt": "color:Yellow | Seibertron Pro 3.0 ultra-stick football receiver gloves image 15"
    },
    {
        "id": "33373093888190",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/football-pro3-youth-gallery-16.jpg?v=1783389183",
        "alt": "color:all | Seibertron Pro 3.0 ultra-stick football receiver gloves image 16"
    },
    {
        "id": "33373093920958",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/football-pro3-youth-gallery-17.jpg?v=1783389183",
        "alt": "color:all | Seibertron Pro 3.0 ultra-stick football receiver gloves image 17"
    }
];
  var groups = {
    "Pink": [
        "33403644707006",
        "33373093396670",
        "33373093429438",
        "33373093462206",
        "33373093888190",
        "33373093920958"
    ],
    "Red": [
        "33434547486910",
        "33373093494974",
        "33373093527742",
        "33373093560510",
        "33373093888190",
        "33373093920958"
    ],
    "White": [
        "33434546667710",
        "33373093593278",
        "33373093626046",
        "33373093658814",
        "33373093888190",
        "33373093920958"
    ],
    "Black": [
        "33434546897086",
        "33373093691582",
        "33373093724350",
        "33373093757118",
        "33373093888190",
        "33373093920958"
    ],
    "Yellow": [
        "33434548142270",
        "33373093789886",
        "33373093822654",
        "33373093855422",
        "33373093888190",
        "33373093920958"
    ]
};
  var entryById = {};
  var colorAliases = {};
  entries.forEach(function (entry) { entryById[entry.id] = entry; });
  Object.keys(groups).forEach(function (color) { colorAliases[color.toLowerCase()] = color; });

  function section() { return document.querySelector('.auto-product[data-product-handle="' + handle + '"]'); }
  function absolute(url) { if (!url) return ''; if (url.indexOf('//') === 0) return window.location.protocol + url; if (url.charAt(0) === '/') return window.location.origin + url; return url; }
  function sized(url, width) { try { var parsed = new URL(absolute(url), window.location.origin); parsed.searchParams.set('width', String(width)); return parsed.href; } catch (error) { return absolute(url); } }
  function escapeHtml(value) { return String(value || '').replace(/[&<>"']/g, function (character) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character]; }); }
  function scriptUrl(file) {
    var own = Array.prototype.find.call(document.scripts, function (script) { return script.src && script.src.indexOf('pro3-gallery-restore-20260713.js') !== -1; });
    if (own) return own.src.replace('pro3-gallery-restore-20260713.js', file);
    return '/cdn/shop/t/16/assets/' + file;
  }
  function ensureStyle() {
    if (document.getElementById('pro3-gallery-restore-style-20260713')) return;
    var style = document.createElement('style');
    style.id = 'pro3-gallery-restore-style-20260713';
    style.textContent = '.auto-product[data-product-handle="' + handle + '"] [data-auto-visual-option-value] [data-auto-choice-label]{width:78px;height:78px;min-width:78px;padding:0!important;overflow:hidden;display:flex;align-items:center;justify-content:center;background:#fff}.auto-product[data-product-handle="' + handle + '"] .auto-product__swatch-image{display:block;width:100%;height:100%}.auto-product[data-product-handle="' + handle + '"] .auto-product__swatch-image img{display:block;width:100%;height:100%;object-fit:contain;background:#fff}.auto-product[data-product-handle="' + handle + '"] .auto-product__swatch-label{position:absolute!important;width:1px!important;height:1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important}';
    document.head.appendChild(style);
  }
  function normalizeColor(value) {
    var key = String(value || '').trim().toLowerCase();
    return colorAliases[key] || value || 'Pink';
  }
  function selectedValue(root) {
    var checked = root.querySelector('input[name="options[Color]"]:checked, input[name="options[color]"]:checked');
    return normalizeColor(checked ? checked.value : 'Pink');
  }
  function groupFor(value) {
    return (groups[normalizeColor(value)] || groups.Pink || []).map(function (id) { return entryById[id]; }).filter(Boolean);
  }
  function setMain(root, entry) {
    var main = root.querySelector('[data-auto-main-image]');
    if (!main || !entry) return;
    main.src = sized(entry.src, 1200);
    main.srcset = '';
    main.alt = entry.alt || main.alt || '';
  }
  function setActiveThumb(root, activeId) {
    root.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
      thumb.classList.toggle('is-active', thumb.getAttribute('data-media-id') === activeId);
    });
  }
  function ensureThumb(root, wrap, entry, index, visibleIds) {
    var thumb = wrap.querySelector('[data-auto-thumb][data-media-id="' + entry.id + '"]');
    if (!thumb) {
      thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'auto-product__thumb';
      thumb.setAttribute('data-auto-thumb', '');
    }
    wrap.appendChild(thumb);
    thumb.setAttribute('data-media-id', entry.id);
    thumb.setAttribute('data-safe-gallery-media', 'true');
    thumb.setAttribute('data-src', sized(entry.src, 1200));
    thumb.setAttribute('data-alt', entry.alt || '');
    thumb.setAttribute('aria-label', 'View image ' + (index + 1));
    thumb.hidden = false;
    thumb.setAttribute('aria-hidden', 'false');
    thumb.innerHTML = '<img src="' + escapeHtml(sized(entry.src, 160)) + '" alt="' + escapeHtml(entry.alt || '') + '" width="76" height="76" loading="' + (index === 0 ? 'eager' : 'lazy') + '">';
    thumb.onclick = function () {
      setMain(root, entry);
      setActiveThumb(root, entry.id);
    };
    visibleIds[entry.id] = true;
  }
  function showGroup(root, value, preferredId) {
    var wrap = root.querySelector('.auto-product__thumbs');
    var group = groupFor(value);
    if (!group.length) return;
    var visibleIds = {};
    if (wrap) {
      group.forEach(function (entry, index) { ensureThumb(root, wrap, entry, index, visibleIds); });
      root.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
        var show = !!visibleIds[thumb.getAttribute('data-media-id')];
        thumb.hidden = !show;
        thumb.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
    }
    var active = entryById[preferredId] && visibleIds[preferredId] ? entryById[preferredId] : group[0];
    setMain(root, active);
    setActiveThumb(root, active.id);
  }
  function hydrateSwatches(root) {
    root.querySelectorAll('[data-auto-visual-option-value]').forEach(function (label) {
      var value = normalizeColor(label.getAttribute('data-auto-visual-option-value') || '');
      var entry = groupFor(value)[0];
      var shell = label.querySelector('[data-auto-choice-label]');
      if (!entry || !shell) return;
      shell.dataset.display = value;
      shell.innerHTML = '<span class="auto-product__swatch-image" aria-label="' + escapeHtml(value) + '"><img src="' + escapeHtml(sized(entry.src, 180)) + '" alt="' + escapeHtml(value) + '" width="78" height="78" loading="lazy"></span><span class="auto-product__swatch-label">' + escapeHtml(value) + '</span>';
    });
  }
  function setChart(img, file, alt) {
    img.src = scriptUrl(file);
    img.srcset = '';
    img.width = 1600;
    img.height = 2200;
    img.alt = alt;
  }
  function replaceCharts(root) {
    var imgs = Array.prototype.slice.call(root.querySelectorAll('img.auto-product__guide-image, img[src*="football-pro3-adult-size-chart"], img[src*="football-pro3-youth-size-chart"]'));
    imgs.forEach(function (img, index) {
      var src = img.getAttribute('src') || '';
      if (src.indexOf('football-pro3-youth-size-chart') !== -1 || index === 1) {
        setChart(img, youthChartFile, 'Seibertron PRO 3.0 youth football receiver gloves size chart');
      } else {
        setChart(img, adultChartFile, 'Seibertron PRO 3.0 adult football receiver gloves size chart');
      }
    });
  }
  function run() {
    var root = section();
    if (!root) return;
    ensureStyle();
    replaceCharts(root);
    hydrateSwatches(root);
    showGroup(root, selectedValue(root));
    if (!root.dataset.pro3GalleryRestoreBound) {
      root.dataset.pro3GalleryRestoreBound = 'true';
      root.addEventListener('change', function (event) {
        if (event.target && event.target.matches('input[name^="options["]')) {
          window.setTimeout(function () { hydrateSwatches(root); showGroup(root, selectedValue(root)); replaceCharts(root); }, 0);
          window.setTimeout(function () { hydrateSwatches(root); showGroup(root, selectedValue(root)); replaceCharts(root); }, 500);
          window.setTimeout(function () { hydrateSwatches(root); showGroup(root, selectedValue(root)); replaceCharts(root); }, 1200);
        }
      });
    }
  }
  run();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  [80, 250, 600, 1000, 1500, 2200, 3000, 3600, 4300, 5500, 7500, 10000].forEach(function (delay) {
    window.setTimeout(run, delay);
  });
})();
